<template>
  <v-card 
    class="map-legend-card" 
    elevation="4"
  >
    <v-card-title class="pa-3 bg-indigo-lighten-5">
      <v-icon class="mr-2" size="small">mdi-map-legend</v-icon>
      <span class="text-body-1">Leyenda del Mapa</span>
    </v-card-title>
    
    <v-card-text class="pa-3">
      <!-- Leyenda de Incidencias -->
      <div 
        v-if="layers.includes('incidents')" 
        class="legend-section mb-4"
      >
        <div class="legend-title">
          <v-icon color="orange" class="mr-2">mdi-alert-circle</v-icon>
          <span class="text-subtitle-2 font-weight-medium">Incidencias</span>
        </div>
        
        <div class="legend-items mt-2">
          <div class="legend-item">
            <div class="legend-marker critical"></div>
            <span class="legend-text">Crítica - Requiere atención inmediata</span>
          </div>
          
          <div class="legend-item">
            <div class="legend-marker high"></div>
            <span class="legend-text">Alta - Prioridad elevada</span>
          </div>
          
          <div class="legend-item">
            <div class="legend-marker medium"></div>
            <span class="legend-text">Media - Gestión normal</span>
          </div>
          
          <div class="legend-item">
            <div class="legend-marker low"></div>
            <span class="legend-text">Baja - Seguimiento rutinario</span>
          </div>
        </div>
        
        <!-- Estados de incidencias -->
        <v-divider class="my-2"></v-divider>
        <div class="legend-subtitle">Estados:</div>
        <div class="legend-items">
          <div class="legend-item">
            <v-icon color="red" size="small">mdi-circle</v-icon>
            <span class="legend-text">Abierta</span>
          </div>
          <div class="legend-item">
            <v-icon color="orange" size="small">mdi-circle</v-icon>
            <span class="legend-text">En Proceso</span>
          </div>
          <div class="legend-item">
            <v-icon color="green" size="small">mdi-circle</v-icon>
            <span class="legend-text">Resuelta</span>
          </div>
        </div>
      </div>

      <!-- Leyenda de Supervisores -->
      <div 
        v-if="layers.includes('supervisors')" 
        class="legend-section mb-4"
      >
        <div class="legend-title">
          <v-icon color="blue" class="mr-2">mdi-account-supervisor</v-icon>
          <span class="text-subtitle-2 font-weight-medium">Supervisores</span>
        </div>
        
        <div class="legend-items mt-2">
          <div class="legend-item">
            <div class="legend-marker supervisor-available"></div>
            <span class="legend-text">Disponible</span>
          </div>
          
          <div class="legend-item">
            <div class="legend-marker supervisor-busy"></div>
            <span class="legend-text">Ocupado</span>
          </div>
          
          <div class="legend-item">
            <div class="legend-marker supervisor-offline"></div>
            <span class="legend-text">Desconectado</span>
          </div>
        </div>
        
        <!-- Tipos de supervisores -->
        <v-divider class="my-2"></v-divider>
        <div class="legend-subtitle">Tipos:</div>
        <div class="legend-items">
          <div class="legend-item">
            <v-icon color="purple" size="small">mdi-account-star</v-icon>
            <span class="legend-text">Field Supervisor</span>
          </div>
          <div class="legend-item">
            <v-icon color="blue" size="small">mdi-account-cog</v-icon>
            <span class="legend-text">POS Supervisor</span>
          </div>
        </div>
      </div>

      <!-- Leyenda de Agencias -->
      <div 
        v-if="layers.includes('agencies')" 
        class="legend-section mb-4"
      >
        <div class="legend-title">
          <v-icon color="green" class="mr-2">mdi-store</v-icon>
          <span class="text-subtitle-2 font-weight-medium">Agencias</span>
        </div>
        
        <div class="legend-items mt-2">
          <div class="legend-item">
            <div class="legend-marker agency-active"></div>
            <span class="legend-text">Activa</span>
          </div>
          
          <div class="legend-item">
            <div class="legend-marker agency-inactive"></div>
            <span class="legend-text">Inactiva</span>
          </div>
          
          <div class="legend-item">
            <div class="legend-marker agency-maintenance"></div>
            <span class="legend-text">Mantenimiento</span>
          </div>
        </div>
        
        <!-- Clustering info -->
        <v-divider class="my-2"></v-divider>
        <div class="legend-subtitle">Agrupación:</div>
        <div class="legend-items">
          <div class="legend-item">
            <div class="legend-cluster">3</div>
            <span class="legend-text">Grupo de agencias</span>
          </div>
        </div>
      </div>

      <!-- Leyenda de Rutas -->
      <div 
        v-if="layers.includes('routes')" 
        class="legend-section mb-4"
      >
        <div class="legend-title">
          <v-icon color="purple" class="mr-2">mdi-routes</v-icon>
          <span class="text-subtitle-2 font-weight-medium">Rutas</span>
        </div>
        
        <div class="legend-items mt-2">
          <div class="legend-item">
            <div class="legend-route active-route"></div>
            <span class="legend-text">Ruta Activa</span>
          </div>
          
          <div class="legend-item">
            <div class="legend-route planned-route"></div>
            <span class="legend-text">Ruta Planificada</span>
          </div>
          
          <div class="legend-item">
            <div class="legend-route completed-route"></div>
            <span class="legend-text">Ruta Completada</span>
          </div>
        </div>
      </div>

      <!-- Información adicional -->
      <v-divider class="my-3"></v-divider>
      
      <div class="additional-info">
        <div class="legend-subtitle mb-2">
          <v-icon size="small" class="mr-1">mdi-information</v-icon>
          Información Adicional
        </div>
        
        <div class="info-items">
          <div class="info-item">
            <v-icon color="primary" size="small">mdi-mouse</v-icon>
            <span class="info-text">Click en marcadores para más detalles</span>
          </div>
          
          <div class="info-item">
            <v-icon color="primary" size="small">mdi-magnify-plus</v-icon>
            <span class="info-text">Zoom para ver elementos individuales</span>
          </div>
          
          <div class="info-item">
            <v-icon color="primary" size="small">mdi-update</v-icon>
            <span class="info-text">Actualización automática cada 30s</span>
          </div>
        </div>
      </div>

      <!-- Estadísticas rápidas de la vista actual -->
      <v-divider class="my-3"></v-divider>
      
      <div class="current-view-stats">
        <div class="legend-subtitle mb-2">
          <v-icon size="small" class="mr-1">mdi-eye</v-icon>
          Vista Actual
        </div>
        
        <div class="stats-grid">
          <div class="stat-item" v-if="layers.includes('incidents')">
            <span class="stat-number">{{ visibleStats.incidents || 0 }}</span>
            <span class="stat-label">Incidencias</span>
          </div>
          
          <div class="stat-item" v-if="layers.includes('supervisors')">
            <span class="stat-number">{{ visibleStats.supervisors || 0 }}</span>
            <span class="stat-label">Supervisores</span>
          </div>
          
          <div class="stat-item" v-if="layers.includes('agencies')">
            <span class="stat-number">{{ visibleStats.agencies || 0 }}</span>
            <span class="stat-label">Agencias</span>
          </div>
          
          <div class="stat-item" v-if="layers.includes('routes')">
            <span class="stat-number">{{ visibleStats.routes || 0 }}</span>
            <span class="stat-label">Rutas</span>
          </div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script setup lang="ts">
interface Props {
  layers: string[]
  visibleStats?: {
    incidents?: number
    supervisors?: number
    agencies?: number
    routes?: number
  }
}

const props = withDefaults(defineProps<Props>(), {
  visibleStats: () => ({
    incidents: 0,
    supervisors: 0,
    agencies: 0,
    routes: 0
  })
})
</script>

<style scoped>
.map-legend-card {
  max-height: 600px;
  overflow-y: auto;
}

.legend-section {
  border-left: 3px solid #e0e0e0;
  padding-left: 12px;
}

.legend-title {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.legend-subtitle {
  font-size: 0.75rem;
  color: #666;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.legend-items {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.legend-text {
  font-size: 0.875rem;
  color: #424242;
}

/* Marcadores de leyenda */
.legend-marker {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 2px solid #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  flex-shrink: 0;
}

/* Incidencias */
.legend-marker.critical {
  background-color: #f44336;
}

.legend-marker.high {
  background-color: #ff9800;
}

.legend-marker.medium {
  background-color: #ffc107;
}

.legend-marker.low {
  background-color: #4caf50;
}

/* Supervisores */
.legend-marker.supervisor-available {
  background-color: #4caf50;
}

.legend-marker.supervisor-busy {
  background-color: #f44336;
}

.legend-marker.supervisor-offline {
  background-color: #9e9e9e;
}

/* Agencias */
.legend-marker.agency-active {
  background-color: #2196f3;
  border-radius: 2px;
}

.legend-marker.agency-inactive {
  background-color: #9e9e9e;
  border-radius: 2px;
}

.legend-marker.agency-maintenance {
  background-color: #ff9800;
  border-radius: 2px;
}

/* Cluster */
.legend-cluster {
  width: 20px;
  height: 20px;
  background-color: #1976d2;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  font-weight: bold;
  flex-shrink: 0;
}

/* Rutas */
.legend-route {
  width: 20px;
  height: 3px;
  flex-shrink: 0;
  border-radius: 2px;
}

.legend-route.active-route {
  background-color: #4caf50;
}

.legend-route.planned-route {
  background-color: #2196f3;
  background-image: repeating-linear-gradient(
    45deg,
    transparent,
    transparent 2px,
    rgba(255, 255, 255, 0.3) 2px,
    rgba(255, 255, 255, 0.3) 4px
  );
}

.legend-route.completed-route {
  background-color: #9e9e9e;
}

/* Información adicional */
.additional-info {
  background: rgba(248, 249, 250, 0.5);
  border-radius: 8px;
  padding: 12px;
}

.info-items {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.info-text {
  font-size: 0.75rem;
  color: #666;
}

/* Estadísticas de vista actual */
.current-view-stats {
  background: rgba(232, 245, 233, 0.3);
  border-radius: 8px;
  padding: 12px;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
  margin-top: 8px;
}

.stat-item {
  text-align: center;
  padding: 8px;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 6px;
}

.stat-number {
  display: block;
  font-size: 1.25rem;
  font-weight: bold;
  color: #1976d2;
}

.stat-label {
  display: block;
  font-size: 0.75rem;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Scrollbar personalizado */
.map-legend-card::-webkit-scrollbar {
  width: 4px;
}

.map-legend-card::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 2px;
}

.map-legend-card::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 2px;
}

.map-legend-card::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Responsive */
@media (max-width: 768px) {
  .stats-grid {
    grid-template-columns: 1fr;
  }
}
</style>
